import { createRouter, createWebHistory } from 'vue-router'
import Homepage from '@/views/homepage/index.vue'
import FunctionDetail from '@/views/homepage/functionDetail.vue'
import Contact from '@/views/contact.vue'
import PrivacyPage from '@/views/privacy.vue'
import ServicePage from '@/views/service.vue'
import DownloadPage from '@/views/download.vue'

const routes = [
  {
    path: '/',
    redirect: '/homepage'
  },
  {
    path: '/homepage',
    name: 'Homepage',
    component: Homepage
  },
  {
    path: '/homepage/functions',
    name: 'FunctionDetail',
    component: FunctionDetail
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPage
  },
  {
    path: '/service',
    name: 'Service',
    component: ServicePage
  },
  {
    path: '/bus/mobile/download',
    name: 'Download',
    component: DownloadPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 兼容移动端：从首页底部点击“联系我们”进入时，必须固定回到联系页顶部
    if (to.path === '/contact') {
      return { left: 0, top: 0 }
    }

    // 浏览器前进/后退时，保留原滚动位置
    if (savedPosition) return savedPosition

    // 其它常规路由切换默认回到顶部
    return { left: 0, top: 0 }
  }
})

export default router

